// Embedded Google Docs/Sheets/Slides editor.
// Works ONLY when the user is signed into Google in the same browser
// and has access to the Shared Drive (handled by Workspace identity).
const GOOGLE_EDITOR_PREFIX = {
  "application/vnd.google-apps.document":     "https://docs.google.com/document/d",
  "application/vnd.google-apps.spreadsheet":  "https://docs.google.com/spreadsheets/d",
  "application/vnd.google-apps.presentation": "https://docs.google.com/presentation/d",
};

export function isGoogleEditable(mimeType) {
  return Boolean(GOOGLE_EDITOR_PREFIX[mimeType]);
}

export default function EditorEmbed({ file }) {
  const prefix = GOOGLE_EDITOR_PREFIX[file.mimeType];
  if (!prefix) return null;
  const src = `${prefix}/${file.id}/edit?rm=embedded`;
  return (
    <iframe
      src={src}
      title={file.name}
      className="w-full h-full border-0"
      allow="autoplay; clipboard-read; clipboard-write"
    />
  );
}
